var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11179_67084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.65335 14C9.53614 14.2021 9.36791 14.3698 9.1655 14.4864C8.96309 14.6029 8.7336 14.6643 8.50001 14.6643C8.26643 14.6643 8.03694 14.6029 7.83453 14.4864C7.63212 14.3698 7.46389 14.2021 7.34668 14",
    stroke: "#33894E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9196 8.66634C12.623 7.58061 12.4816 6.45837 12.4996 5.33301",
    stroke: "#33894E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.67333 4.17285C4.55751 4.54859 4.49907 4.93967 4.5 5.33285C4.5 9.99952 2.5 11.3329 2.5 11.3329H11.8333",
    stroke: "#33894E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 5.33308C12.5013 4.60846 12.3056 3.89715 11.9338 3.27514C11.5621 2.65314 11.0284 2.14379 10.3897 1.80151C9.751 1.45923 9.03132 1.29688 8.30754 1.3318C7.58376 1.36671 6.88305 1.59758 6.28027 1.99975",
    stroke: "#33894E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.16699 0.666992L15.8337 15.3337",
    stroke: "#33894E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11179_67084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellOff);
export default __webpack_public_path__ + "static/media/Bell-off.32f345524f6be6e76d20452839941a5a.svg";
export { ForwardRef as ReactComponent };